.scenarioPage {
  padding: 24px;
}
